<section class="video-upload">
  <div class="upload-form-column">
    <h2>{{ isEditing() ? 'Editar Video' : 'Añadir Video a la Cola' }}</h2>
    <div class="quality-hint">
      <mat-icon>help</mat-icon>
      <span>Asegúrate de subir vídeos con calidad 720p o superior.</span>
    </div>

    <form>
      <div class="form-group">
        <label for="title">Título del video</label>
        <input id="title" name="title" [(ngModel)]="title" type="text" placeholder="Introduce el título del vídeo..." />
      </div>

      <div class="form-group">
        <label for="description">Descripción</label>
        <textarea id="description" name="description" [(ngModel)]="description"
          placeholder="Añade una descripción del vídeo..."></textarea>
      </div>

      <div class="form-group">
        <label for="seasonId">Temporada</label>
        <select
          id="seasonId"
          name="seasonId"
          [ngModel]="seasonId()"
          (ngModelChange)="seasonId.set($event)">
          <option [ngValue]="1">Temporada actual (ID 1)</option>
          @for (season of seasons(); track season.id) {
            <option [ngValue]="season.id">{{ season.name }}</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="matchDate">Fecha del partido</label>
        <input
          id="matchDate"
          name="matchDate"
          type="date"
          [ngModel]="matchDate()"
          (ngModelChange)="matchDate.set($event)" />
      </div>

      <div class="form-group">
        <ng-content></ng-content>
      </div>
    </form>
  </div>

  <div class="upload-form-column upload-file-column">
    <app-rfebm-primary-button [isDisabled]="!isFormValid() || !selectedFile" (click)="onAddVideoClick()">
      {{ isEditing() ? 'Guardar Cambios' : 'Añadir a la lista' }}
    </app-rfebm-primary-button>

    <app-drag-drop-files [label]="'Arrastra y suelta tu video aquí (MP4, AVI, MOV)'" [allowMultipleFiles]="false"
      [allowedExtensions]="['.mp4', '.avi', '.mov']" [files]="selectedFile ? [selectedFile] : []"
      (onFilesDropped)="onFileSelected($event)"></app-drag-drop-files>

    @if (selectedFile && selectedFileWidth && selectedFileHeight) {
    <div class="video-quality-info" [class.invalid]="!!selectedFileResolutionError">
      <mat-icon>{{ selectedFileResolutionError ? 'warning' : 'high_quality' }}</mat-icon>
      <span>
        Resolución detectada: {{ selectedFileWidth }}x{{ selectedFileHeight }}
        @if (selectedFileResolutionError) { · {{ selectedFileResolutionError }} }
      </span>
    </div>
    }

    @if (selectedFile && selectedFileResolutionError && (!selectedFileWidth || !selectedFileHeight)) {
    <div class="video-quality-info invalid">
      <mat-icon>warning</mat-icon>
      <span>{{ selectedFileResolutionError }}</span>
    </div>
    }

    <app-drag-drop-files class="pdf-uploader" [label]="'Arrastra y suelta el acta (PDF, Opcional)'"
      [allowMultipleFiles]="false" [allowedExtensions]="['.pdf']" [files]="selectedRecord ? [selectedRecord] : []"
      (onFilesDropped)="onRecordSelected($event)"></app-drag-drop-files>

    <div *ngIf="errorMessage" class="error-alert">
      {{ errorMessage }}
    </div>
  </div>
</section>
